import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Container } from '@material-ui/core';
import SearchingImage from '../../design-system/assets/images/theme/searching.svg';

const NothingFound = ({caption, subcaption, type, width = '200px', children}) => {
    return (
        <Container maxWidth="lg">
            <Box display="flex" justifyContent="center" flexDirection="column" className="my-4">
                <Box display="flex" justifyContent="center" className="mb-4">
                    <img alt={caption} src={SearchingImage} draggable="false" style={{ maxWidth: width }} />
                </Box>
                <Box display="flex" justifyContent="center" textAlign="center" flexDirection="column">
                    <Typography variant="subtitle1" className="mb-1" color="primary">
                        {caption}
                    </Typography>
                    <Typography variant="body1">
                        {subcaption}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="center" textAlign="center" flexDirection="column">
                    {children}
                </Box>
            </Box>
        </Container>
    );
};

NothingFound.defaultProps = {
    caption: 'Sin Contenido',
    subcaption: '',
    type: 'search'
};

NothingFound.propTypes = {
    caption: PropTypes.string,
    subcaption: PropTypes.string,
    type: PropTypes.string
};

export default NothingFound;
